import { render, staticRenderFns } from "./Todas.vue?vue&type=template&id=7910e542&"
import script from "./Todas.vue?vue&type=script&lang=js&"
export * from "./Todas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports